import { render, staticRenderFns } from "./cliengo.vue?vue&type=template&id=6ec01b88"
import script from "./cliengo.vue?vue&type=script&lang=js"
export * from "./cliengo.vue?vue&type=script&lang=js"
import style0 from "./cliengo.vue?vue&type=style&index=0&id=6ec01b88&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports